export default "__VITE_ASSET__C58_eKOO__"